export default "__VITE_ASSET__f910cbc1__"